import { Stack } from "@mui/material";
import { ShopModule } from "../../../types/shopModuleTypes";
import ShopButton from "../../../components/common/table/ShopButton";

interface ShopModuleIconListProps {
  shopModules: ShopModule[];
}

export default function ShopModuleIconList(props: ShopModuleIconListProps) {
	return (
		<Stack direction="row" sx={{ overflow: "hidden", gap: 0.5 }}>
			{props.shopModules.map((module) =>
				<ShopButton type={module.type}/>
			)}
		</Stack>
	);
}